import produce from 'immer';
import { Reducer } from 'redux';

import { RecoveryTypes } from '../actions/recoveryActions';
import {
    INITIAL_RECOVERY, initialRecoveryState,
    LOGIN_RECOVERY,
    LOGIN_RECOVERY_ANSWER,
    LOGIN_RECOVERY_ANSWER_FAILED,
    LOGIN_RECOVERY_ANSWER_SUCCESSFUL,
    LOGIN_RECOVERY_FAILED,
    LOGIN_RECOVERY_RESET,
    LOGIN_RECOVERY_SUCCESSFUL,
} from '../constants/recoveryConstants';
import { IRecoveryState } from '../types/recoveryTypes';

const recoveryReducer: Reducer<IRecoveryState> =
    (state: IRecoveryState = initialRecoveryState, action: RecoveryTypes) =>
    produce(state, draft => {
        switch (action.type) {
            case LOGIN_RECOVERY:
                break;
            case LOGIN_RECOVERY_SUCCESSFUL:
                draft.loginRecovery = action.payload;
                break;
            case LOGIN_RECOVERY_FAILED:
                draft.errorMessage = action.payload;
                break;
            case LOGIN_RECOVERY_RESET:
                draft.loginRecovery = null;
                draft.recoveryAnswer = null;
                break;
            case INITIAL_RECOVERY:
                break;
            case LOGIN_RECOVERY_ANSWER:
                break;
            case LOGIN_RECOVERY_ANSWER_SUCCESSFUL:
                draft.recoveryAnswer = action.payload;
                break;
            case LOGIN_RECOVERY_ANSWER_FAILED:
                draft.recoveryAnswer = null;
                draft.errorMessage = action.payload;
                break;
            default:
                break;
        }
    });

export default recoveryReducer;
